import React, { useEffect, useState } from 'react';
import SpiderwebView from './OldSpiderwebMap/SpiderwebView';
import { Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import LoadingSpinner from 'components/reusable/LoadingSpinner.js';
import { getBasicData } from 'store/entities/spiderWeb/thunks';
import SearchResultsTable from './SearchBlock/SearchResultsTable';
import { setIsSpiderwebOpen } from 'store/entities/spiderWeb';

const Spiderweb = () => {
  const dispatch = useDispatch();
  const { basicDataPending, isSpiderwebOpen } = useSelector(state => state.spiderWeb);

  const spiderParams = JSON.parse(localStorage.getItem('spiderParams'));
  useEffect(() => {
    if (spiderParams) {
      dispatch(setIsSpiderwebOpen(true));
      dispatch(getBasicData(spiderParams));
      localStorage.removeItem('spiderParams');
    }
  }, [spiderParams]);

  return (
    <LoadingSpinner spinning={basicDataPending}>
      <Row className="container">
        <Col span={24}>
          <SearchResultsTable />
          {isSpiderwebOpen && <SpiderwebView />}
        </Col>
      </Row>
    </LoadingSpinner>
  );
};

export default Spiderweb;
